import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureLeadData, successLeadData } from "./Leads/LeadViewdata/LeadData";
import { failureSessionRead, successSessionRead } from "./Leads/Session/SessionRead";
import { failureSession_Crud, successSession_Crud } from "./Leads/Session/Session_crud";


// cards data
const LeadDataApi = () => {
  return api.get("/api/crm-kanban/get-lead-data");
};

export function* LeadDataCall() {
  try {
    const response: AxiosResponse = yield call(LeadDataApi);
    yield put(successLeadData(response.data));
  } catch (error) {
    yield put(failureLeadData(error));
  }
}


const SessionReadApi = () => {
  return api.get("/api/crm-session/list-sessions");
};

export function* SessionReadCall() {
  try {
    const response: AxiosResponse = yield call(SessionReadApi);
    yield put(successSessionRead(response.data));
  } catch (error) {
    yield put(failureSessionRead(error));
  }
}


const Session_CrudApi  = (action: PayloadAction<any>) => {
  return api.post("/api/crm-session/create-edit-session", action.payload);
};

export function* Session_CrudCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      Session_CrudApi ,
      action
    );
    yield put(successSession_Crud(response.data));
  } catch (error) {
    yield put(failureSession_Crud(error));
  }
}

